import React from "react";
import "./ImageModal.css";

export default function ImageModal({ imageUrl, onClose }) {
  if (!imageUrl) return null;

  return (
    <div className="image-modal-overlay" onClick={onClose}>
      <div className="image-modal" onClick={(e) => e.stopPropagation()}>
        <button className="image-close" onClick={onClose}>✖</button>
        <img src={imageUrl} alt="Agrandie" className="image-content" />
      </div>
    </div>
  );
}
